const ja = {
  'Language Key': 'ja',
  'cui-org-info': '組織情報',
  'cui-sign-on-info': '情報にサイン',
  'cui-user-info': 'ユーザー情報',
  'cui-preferences': '環境設定',
  'cui-review': 'レビュー',
  'cui-org': '組織',
  'cui-company-division': '企業/部門',
  'cui-org-address': '組織の住所',
  'cui-user-address': 'ユーザーの住所',
  'cui-country': '国',
  'cui-city': 'シティ',
  'cui-state': '州/地方',
  'cui-postal': '郵便番号',
  'cui-user-id': 'ユーザーID',
  'cui-password': 'パスワード',
  'cui-password-re': 'パスワード再入力',
  'cui-challenge-question': 'チャレンジ質問',
  'cui-challenge-answer': 'チャレンジの回答',
  'cui-favorite-pet-q': 'あなたの好きなペットの名前は何ですか？',
  'cui-mother-q': 'あなたの母親の旧姓は何ですか？',
  'cui-best-friend-q': '一番の親友は誰ですか？',
  'cui-first-name': 'ファーストネーム',
  'cui-last-name': '苗字',
  'cui-email': 'Eメール',
  'cui-email-re': '再入力した電子メールを',
  'cui-telephone': '電話番号',
  'cui-timezone': 'タイムゾーン',
  'cui-submit': 'SUBMIT',
  'cui-next': '次のステップ',
  'cui-previous': '前',
  'cui-create-security-admin-account': 'セキュリティ管理者アカウントを作成します。',
  'cui-skip-for-now': '今のところスキップ',
  'icon-library': 'アイコンライブラリ',
  'cui-new-TLO': '新しいトップレベルの組織',
  'cui-new-TLO-description': '新しいCovisintの組織としてCovisintの取引に参加することを希望する場合は、この方法を選択',
  'cui-new-division': '新部門',
  'cui-new-division-description-start': 'あなたがなりたい場合は、この方法を選択',
  'cui-new-division-description-end': '既存のCovisintの組織内の新部門の。',
  'cui-security-administrator': 'セキュリティ管理者',
  'cui-new-user': '新しいユーザー',
  'cui-new-user-description': 'あなたの組織がするか、あなたの組織が登録されているかどうかわからない場合は加入するアプリケーションへのアクセスを求めている既存のCovisintの会員企業の従業員である場合は、この方法を選択します。',
  'cui-sign-up': 'サインアップ',
  'cui-address': '住所',
  'cui-organization-name': '企業/部門',
  'cui-supplier-code': '取引先コード',
  'cui-address-1': '住所（1',
  'cui-address-2': 'アドレス2',
  'cui-user-information': 'ユーザー情報',
  'cui-organization-information': '組織情報',
  'cui-sign-in-information': '情報サインイン',
  'cui-package-selection': 'パッケージの選択',
  'cui-welcome-popover': 'あなたが登録方法を選択した後、セキュリティ管理者の責務について詳細に説明します。しかし、あなたはあなたのOrganiziationの異なるメンバーは、セキュリティ管理者として登録することを可能にするために、あなたの登録を解除することもできます。',
  'create-account': 'アカウントを作成',
  'cui-agree-covisint': '私はCovisintのに同意します',
  'terms-of-service': '利用規約',
  'cui-and': 'そして',
  'privacy-policy': '個人情報保護方針',
  'cui-tos-agree': '続行するにはサービス規約に同意しなければなりません。',
  'cui-user-profile': 'ユーザープロファイル',
  'cui-my-profile': '私のプロフィール',
  'cui-login': 'ログイン',
  'cui-supplier-content': '設計ドキュメントが入って来たら、これを更新します。これは、翻訳Googleドキュメントです。 Loremのイプサム。他のもの。サプライヤーコードの重要な情報。私は亀が好きです。',
  'cui-all-organizations': 'すべての組織：',
  'cui-application-select-info': 'あなたは、常に最初にログインした後、あなたの選択を行うことができます。',
  'cui-all-applications': 'すべてのアプリケーション',
  'cui-page-not-found': 'ページが見つかりません',
  'cui-page-not-found-content': 'あなたが探しているページは削除されていないか、または決して存在していました。',
  'cui-home': 'HOME',
  'cui-access-denied': 'アクセスが拒否されました',
  'cui-access-denied-content': 'あなたは、このページを表示する権限がありません。',
  'cui-registration-status': '登録状況',
  'cui-pending-status': '保留状態',
  'cui-pending-status-content': 'あなたの登録状況はまだ保留されています。あなたはすぐに詳細を記載したメールが届きます。',
  'cui-thank-you': 'ありがとうございました',
  'cui-request-submitted': '要求提出',
  'cui-success': '成功',
  'cui-success-content': 'あなたのCovisintの登録が正常に送信されました。あなたはすぐに詳細を記載したメールが届きます。',
  'cui-check-your': 'あなたをチェック',
  'cui-registration-status-lower': '登録状況',
  'cui-application-selection': 'アプリケーション選択',
  'cui-applications': 'アプリケーション',
  'cui-profile-settings': 'プロフィールの設定',
  'cui-name': '名',
  'cui-update': '更新',
  'cui-updated': '更新しました',
  'cui-error-try-again': 'エラー！再試行する？',
  'cui-back': 'バック',
  'cui-selections': '選択',
  'cui-add-org': '組織を追加',
  'cui-remove-org': '組織を削除します',
  'cui-select-org': '組織を選択',
  'cui-more-information': '詳しくは',
  'cui-inv-user-popover-info': 'セキュリティ上の理由から、あなたの招待状が送信された電子メールに登録する必要があります。登録が完了すると、これはユーザー設定内で編集することができます。',
  'cui-org-profile': '組織のプロフィール',
  'cui-info': 'インフォ',
  'cui-admins': '管理者',
  'lowercase-not-allowed': '任意の小文字を持っていません',
  'uppercase-not-allowed': '任意の大文字を持っていません',
  'numbers-not-allowed': '任意の数字を持っていません',
  'special-not-allowed': '特別なシンボルを持っていません（例：！* +）',
  'chars-not-allowed': '次の文字を含まないこと：{{disallowedChars}}',
  'words-not-allowed': '次の単語を含まないこと：{{disallowedWords}}',
  'password-length': '文字数が {{min}}～{{max}}文字であること',
  'password-rules': '次のうち{{requiredNumberOfCharClasses}}つを含むこと',
  'password-lowercase': '少なくとも1つの小文字',
  'password-uppercase': '少なくとも1つの大文字',
  'password-number': '少なくとも1の数',
  'password-special': '少なくとも1特殊記号（例：！* +）',
  'passwords-must': 'パスワードは次の条件を満たす必要があります。',
  'welcome-title': '次のいずれかに登録',
  'cui-application-name': 'アプリケーション名',
  'cui-application-tos': 'レビュー利用規約',
  'cui-application-tos-agreement': '利用規約同意書',
  'cui-package-tos': 'あなたは、選択したパッケージのための条件を受け入れていません。',
  'cui-view-tos': 'ビューの利用規約',
  'password-mismatch': 'パスワードが一致する必要があります',
  'cui-back-to-review': '戻るレビューへ',
  'email-mismatch': '電子メールは一致している必要があります',
  'no-applications-selected': 'あなたは、任意のアプリケーションが選択されていません。バックアプリケーション選択へ行くにはこちらをクリックしてください。',
  'cui-all-fields-required': '全て必須項目です',
  'cui-complete-registration': 'で、以下の登録を完了します',
  'cui-registered': '登録',
  'cui-open': '開いた',
  'cui-close': '閉じる',
  'cui-street-address': '住所',
  'cui-zip': 'ジップ',
  'cui-language': '言語',
  'cui-phone-main': 'メイン',
  'cui-phone-office': 'オフィス',
  'cui-phone-fax': '電話/ファックス',
  'cui-phone-mobile': 'モバイル',
  'cui-save': 'セーブ',
  'cui-cancel': 'キャンセル',
  'cui-edit': '編集します',
  'cui-phone': '電話',
  'search-by-app-name': 'アプリケーション名で検索',
  'new-request': '新しいリクエスト',
  'select-applications': 'アプリケーションを選択',
  'browse-applications': 'アプリケーションを参照',
  'go': '行きます',
  'filter-list': 'フィルタリスト',
  'filter': 'フィルタ',
  'owning-org': '所有している組織',
  'my-applications': 'マイアプリケーション',
  'app-summary': 'アプリの概要',
  'granted': '確かに',
  'bundled-applications': 'バンドルアプリケーション',
  'application-details': 'アプリケーションの詳細',
  'my-claims': '私の主張',
  'related-applications': '関連アプリケーション',
  'review-request': 'レビューリクエスト',
  'back-to-search': '戻る検索へ',
  'requested-items': '要求されたアイテム',
  'request-reason': '要請の理由',
  'reason-im-requesting': '私は要求していた理由',
  'you-must-enter-a-reason': 'あなたは、このアプリを要求する理由を入力する必要があります',
  'cui-org-no-applications': 'あなたの組織は、すべてのアプリケーションを持っていないように思えます。あなたは、常にログイン後に再度お試しすることができます。',
  'cui-filter-org-name': '組織名でフィルタ',
  'cui-address-example': 'アプト、スイート、ビル。 （オプション）',
  'cui-filter-app-name': 'アプリケーション名でフィルタ',
  'cui-search-user-name': '名前で検索するユーザー',
  'page': 'ページ',
  'cui-num-results-page': 'ページ毎の結果',
  'submit-request': 'リクエストを送信',
  'categories': 'カテゴリー',
  'cui-answer': '回答',
  'cui-enter-password': 'パスワードを入力する',
  'cui-enter-new-password': '新しいパスワードを入力してください',
  'cui-re-enter-new-password': '新しいパスワードを再入力してください',
  'granted-to-my-org': '私の組織に付与されました',
  'collected-items-for-request': 'リクエストのために収集したアイテム',
  'cui-invalid-password': '無効なパスワード。もう一度やり直してください。',
  'cui-faq': 'よくある質問',
  'cui-frequently-asked-questions': 'よくある質問',
  'cui-admin-tools': '管理ツール',
  'cui-this-field-is-required': 'この項目は必須です。',
  'cui-this-field-needs-to-be-longer': 'このフィールドは長くする必要があります。',
  'cui-you-need-to-agree-to-toc': 'あなたが続ける前にサービスの利用規約に同意する必要があります。',
  'cui-this-is-not-valid-email': 'これは、有効な電子メールではありません。',
  'cui-my-app-requests': '私のアプリケーション要求',
  'cui-no-claims': 'あなたはこのアプリケーションのための主張を持っていません。',
  'cui-no-details': 'なし詳細。',
  'request': '要求',
  'all': 'すべて',
  'no-selected-apps': 'あなたは、任意のアプリケーションを選択していません。',
  'basic-info': '基本情報',
  'cui-error-username-exists': 'ユーザーIDはすでに存在しています！別のものをお選びください。',
  'password-reset': 'パスワードのリセット',
  'current-password': '現在のパスワード',
  'timezone-and-language': 'タイムゾーンと言語',
  'challenge-questions': 'チャレンジ質問',
  'security-question-repeated': 'この答えは、すでに使用されています。',
  'cui-by-date-added': '追加された日付',
  'cui-alphabetically': 'アルファベット順',
  'active': 'アクティブ',
  'pending': '保留中',
  'suspended': '一時停止',
  'title': 'タイトル',
  'id': 'ID',
  'url': 'URL',
  'privacy-terms': 'プライバシーと利用規約',
  'help': '助けて',
  'cui-learn-more-start': 'もっと詳しく知る',
  'cui-learn-more-end': '私たちは、この情報を求める理由について',
  'cui-org-hierarchy': '組織階層',
  'directory': 'ディレクトリ',
  'userID': 'ユーザーID',
  'status': '状態',
  'locked': 'ロック',
  'rejected': '拒否されました',
  'removed': '削除されました',
  'sort': 'ソート',
  'refine': 'リファイン',
  'or': '若しくは',
  'organizations': '組織',
  'roles': '役割',
  'organization-applications': '組織アプリケーション',
  'unactivated': '活性化されていません',
  'log-out': 'ログアウト',
  'welcome': 'ようこそ',
  'privacy': 'プライバシー',
  'terms': '条項',
  'user': 'ユーザー',
  'top-level-orgs': 'トップレベルの組織',
  'invite-user': 'ユーザーを招待',
  'invite-division': '部門を招待',
  'username': 'ユーザー名',
  'move': '動き',
  'no-bundled-or-related': 'いいえバンドルまたは関連アプリケーションません。',
  'cui-continue': '持続する',
  'cui-no-org-divisions': 'いかなる組織部門ません',
  'inactive': '不活発',
  'deny': '否定します',
  'approve': '認めます',
  'pending-request': '保留中の要求',
  'review-approvals': 'レビュー承認',
  'cui-package-no-claims': 'このパッケージには、何の主張が含まれていません',
  'claims': 'クレーム',
  'package-name': 'パッケージ名',
  'submit-approvals': '承認を提出',
  'view-details': '詳細を見る',
  'request-date': 'リクエストの日付',
  'registration-decision': '登録決定',
  'requested': '要求されました',
  'getting-user-info': 'ユーザー情報を取得中...',
  'approvals-submitted': '提出された承認',
  'rejection-submitted': '拒絶提出',
  'approval-summary': '承認の概要',
  'approved-items': '承認されたアイテム',
  'rejected-items': '拒否されたアイテム',
  'registration-request-approved': '承認された登録要求',
  'registration-request-rejected': '拒否された登録要求',
  'no-items-rejected': '商品は拒否されません',
  'no-items-approved': '商品は、承認されていません',
  'registration-request': '登録要求',
  'custom-api-loading': 'アプリを初期化しています...',
  'new-grant': '認可アプリ',
  'search-by-package-name': 'パッケージ名で検索',
  'search': 'サーチ',
  'administartor-?': '管理者？',
  'submit-grant-update': '助成金の更新を送信',
  'review-user-pending-approval': 'レビューユーザー承認待ち',
  'view-request-for': '見る要求',
  'job-title': '職名',
  'query': '質問',
  'suspend-app': 'アプリケーションをサスペンド',
  'new-grants': '新しい補助金',
  'update-grant-settings': '更新グラント設定',
  'assign-new-grant-to': '新しい助成金の割り当て',
  'division': '分割',
  'redirecting-to-sso': '資格情報を要求します',
  'included-applications': '付属のアプリケーション',
  'selected-sub-packages': '選択されたサブパッケージ',
  'specify-password': 'パスワードを指定します',
  'suspend': 'サスペンド',
  'reset-password': 'パスワードを再設定する',
  'confirm-password-reset': 'あなたは、このユーザのパスワードをリセットしてもよろしいですか？',
  'yes': 'はい',
  'within': '以内',
  'search-within': '内検索',
  'in-your-org': 'あなたの組織で',
  'people': '人',
  'revoke-package': 'パッケージを取り消し',
  'cui-by-username': 'ユーザー名',
  'cui-by-status': '状態',
  'cool-got-it': 'クール、それを得ました',
  'organization-directory': '組織ディレクトリ',
  'org-nav-invite-links': '組織ナビゲーションと招待リンク',
  'org-dir-filters': '組織のディレクトリフィルタ',
  'org-dir-list': '組織のディレクトリ一覧',
  'apps': 'アプリ',
  'apps-upper': 'アプリ',
  'history-upper': '歴史',
  'profile-upper': 'プロフィール',
  'roles-upper': '役割',
  'your-app-request-in-review': 'アプリケーションの要求が送信されました',
  'error-generic': 'このページのデータをロードする問題がありました。もう一度やり直してください。',
  'cui-application-administrator': '現在のユーザーが特定のアプリケーションの管理権限を付与することができます前に割り当てられなければならないアプリケーション管理者の役割を持っていません。これは、1時間の設定です。',
  'cui-assign-confirm': 'あなたは今、この役割を割り当てるようにしませんか？',
  'cui-suspend-warning': 'このアプリケーションにアクセスすることができません',
  'cui-suspend-confirm': 'あなたは今、中断してもよろしいですか？',
  'cui-notify-user': 'ユーザーに通知',
  'cui-users': 'ユーザー',
  'cui-no': 'ノー',
  'cui-remove': '削除されました',
  'cui-org-abbrev': '組織',
  'cui-userProfile-user-error': 'ユーザーデータの取得中にエラーが発生しました。もう一度やり直してください。',
  'cui-userProfile-security-error': 'セキュリティの質問データの取得中にエラーが発生しました。もう一度やり直してください。',
  'cui-userProfile-password-error': 'パスワードポリシーデータの取得中にエラーが発生しました。もう一度やり直してください。',
  'cui-suspend-success': 'このアプリケーションは、現在選択されているユーザーから吊り下げられています',
  'cui-unlock': 'アンロック',
  'cui-unlock-password-confirm': 'あなたは、このユーザのパスワードのロックを解除したいことを確認していますか？',
  'cui-error-unlocking-password': '申し訳ありませんが、このユーザのパスワードをアンロックにエラーが発生しました。',
  'cui-error-person-request': 'このユーザーの登録要求データを取得できません。',
  'cui-error-email-exists': '電子メールアドレスは、すでに使われています',
  'cui-password-history-rule': 'あなたの前の{{numberOfPasswords}}パスワードのいずれかと一致しません',
  'cui-password-policy': 'パスワードポリシー',
  'cui-security-admin': 'セキュリティ管理者',
  'cui-button-loading-text': '読み込んでいます...',
  'cui-username-taken': 'ユーザー名が取られています',
  'cui-no-applications': 'あなたは現在、どのアプリケーションを持っていません',
  'cui-mask-answers': 'マスク/マスク解除セキュリティの回答',
  'cui-pwd-reset-success': 'パスワードは、成功をリセット！',
  'cui-last-login': '前回のログイン',
  'cui-need-different-app': '別のアプリケーションが必要です',
  'cui-go-back-to': '帰ります',
  'cui-tos-applications': '選択したアプリケーションの利用規約に同意してください',
  'cui-selected-apps': '選択したアプリケーション',
  'cui-authentication-policy': '認証ポリシー',
  'cui-selected': '選択',
  'cui-tac': '規約と条件',
  'cui-accept': '受け入れます',
  'cui-tac-agree': '続行するには利用規約に同意する必要があります。',
  'cui-printer-friendly-tac': '印刷用利用規約',
  'cui-my-history': '私の歴史',
  'cui-status-history': 'マイステータス履歴',
  'cui-app-history': 'アプリケーションの歴史',
  'cui-password-change-log': 'パスワードの変更ログ',
  'cui-date': '日付',
  'cui-event-type': 'イベントタイプ',
  'cui-action-by': 'によって実行されるアクション',
  'cui-notes': 'ノート',
  'cui-try-again': 'もう一度やり直してください。',
  'cui-password-change-log-error': 'パスワードの変更ログを取得中にエラーがありました。',
  'cui-userstatus-history-error': 'ユーザステータスの履歴を取得中にエラーがありました。',
  'cui-claims-error': 'クレームの取得にエラーが発生しました。',
  'cui-org-app-suspend-success': 'このアプリケーションは、現在選択された組織で、すべてのユーザー、およびすべてのサブ組織から吊り下げられています。',
  'cui-org-app-suspend-msg1': 'このアクションは、場合でも、アクティブに使用中のすべてのユーザーとサブ機関からアクションを一時停止します。',
  'cui-org-app-suspend-msg2': 'あなたが中断したい確信しています',
  'cui-from': 'から',
  'cui-application-granted-history': 'アプリケーション・グラントの歴史',
  'cui-application-requested-history': 'アプリケーション要求の歴史',
  'approved': '承認',
  'decision': '決定',
  'evaluator': 'エバリュエータ',
  'action': 'アクション',
  'cui-invalid-invitation': '招待状は既に使用されるか、または無効されますか',
  'cui-by-request-date': 'リクエストの日付',
  'cui-by-decision-date': '決定日',
  'cui-no-orgs-for-name': '指定された名前が見つかりません団体。別の名前で試してみてください。',
  'requests': 'リクエスト',
  'no-pending-apps': 'あなたは保留中のアプリケーション要求を持っていません。',
  'description': '説明',
  'launch': '打ち上げ',
  'manage-applications': 'アプリケーションの管理',
  'request-type': 'リクエストの種類',
  'phase': '段階',
  'date-submitted': '日提出',
  'cui-pending-requests-error': 'リクエストの更新/取得中にエラーが発生しました。',
  'no-requests-by-name': '指定された名前が見つかりません要求。別の名前で試してみてください。',
  'cannot-change-password': '今すぐパスワードを変更することはできません',
  'select-claims': 'クレームを選択',
  'grant-reason': 'グラント理由',
  'grants-assigned': '割り当てられた新しい補助金',
  'suspend-error': 'リクエストを保留中にエラーが発生しました。',
  'unsuspend-error': '停止解除要求中にエラーが発生しました。',
  'approval': '承認',
  'administrator': '管理者',
  'submitted': '提出',
  'no-bundled': 'いいえバンドルアプリケーションません',
  'disallowed-password-rule': '禁止単語リストに単語を含めることはできません',
  'request-approve-or-rejected': 'この要求は、いずれかの拒否/承認されます',
  'application': '応用',
  'show-all': 'すべて表示する',
  'cui-subject': '主題',
  'cui-es': '（ES）',
  'cui-invite-user': '内のユーザーを招待',
  'cui-invite-user-success': '送信されたユーザーの招待要求',
  'cui-email-recipt': '受信者のメールアドレスを入力（カンマで区切り複数）',
  'cui-invite-verbiage': '次のいずれかの招待',
  'select': '選択',
  'change-org': '変更組織',
  'cui-invite-user-sub': '参加するにはユーザー登録',
  'cui-invite-user-select': '組織を検索します',
  'cui-send-invitation': '招待状を送ります',
  'invite': '招待する',
  'cui-invite-tlo-success': 'あなたのトップレベルの組織の招待要求が送られました',
  'cui-invite-tlo': '新しい組織を招待',
  'cui-invite-division-success': 'あなたの会社の招待リクエストが送信され',
  'cui-invite-division': '組織を招待',
  'cui-tlo-sub': '新しい組織として登録',
  'cui-division-sub': '内adminstratorとして登録',
  'search-by-org-name': '組織名で検索',
  'app-approval-error': 'App要求を承認中にエラーが発生しました。',
  'modify-claims': 'クレームを変更',
  'unsuspend-app': '中断解除のApp',
  'remove-app': 'アプリケーションを削除します',
  'user-details': 'ユーザー詳細',
  'reason': '理由',
  'required': '必須',
  'cui-unsuspend-confirm': 'あなたは今の中断を解除してもよろしいですか？',
  'unsuspend': '中断解除',
  'remove-confirm': 'あなたは今削除してもよろしいですか？',
  'remove': '取り除きます',
  'my-organization': '自分の所属組織',
  'request-app': 'リクエストのApp',
  'no-apps-found': 'どのアプリケーションが見つかりませんでした。',
  'refine-search': '検索条件を絞り込んでください。',
  'your-assign-role-success': '割り当てられた新しい役割',
  'cui-assigned-roles': '割り当てられた役割',
  'cui-available-roles': '利用可能なロール',
  'cui-browse-by-category': 'カテゴリ別にブラウズ',
  'cui-back-navigation-requests': '戻るナビゲーションと要望',
  'cui-search-results': 'の検索結果',
  'cui-new-grant-search-results': '新しいグラントの検索結果',
  'cui-username-close': 'ユーザー名と近いナビゲーション',
  'cui-user-no-apps': 'ユーザーには、アプリケーションを持っていません',
  'cui-no-roles-assigned': 'このユーザーには割り当てられた役割を持っていません。',
  'status-history': 'ステータス履歴',
  'cui-no-status-history': 'このユーザーには、ステータスの歴史を持っていません。',
  'cui-pwd-reset-msg1': 'パスワードリセットは成功です。新しいパスワードは次のとおりです。',
  'cui-pwd-reset-msg2': '注：前半だけパスワードを見ているならば、後半パスワードがユーザーに送信される電子メールを登録。',
  'users-upper': 'ユーザー',
  'hierarchy-upper': '階層',
  'privileges': '特権',
  'expand-all': 'すべて展開',
  'collapse-all': 'すべて折りたたみます',
  'no-records': 'レコードが見つかりません。',
  'contact-us': 'お問い合わせ',
  'cui-error-organization-request': 'この組織のための登録要求データを取得できません。',
  'cui-error-organization-app-request': 'この組織のためのアプリケーション要求データを取得できません',
  'cui-error-user-app-request': 'このユーザーのためのアプリ要求データを取得できません',
  'assign': '割り当てます',
  'search-by-person-name': '人物名で検索',
  'grant-history': 'グラントの歴史',
  'request-history': 'リクエストの歴史',
  'social-login': '社会ログイン',
  'facebook': 'フェイスブック',
  'twitter': 'さえずり',
  'link': 'リンク',
  'unlink': 'リンク解除',
  'invalid-url': 'これは有効なURLではありません。',
  'linkedin': 'LinkedInの',
  'google': 'グーグル',
  'administration': '行政',
  'services': 'サービス',
  'n-phase': 'N  - フェーズ承認',
  'edit-package': '編集パッケージ',
  'is-requestable': '要求可能です',
  'is-displayable': '表示可能',
  'is-grantable': 'GRANTABLEです',
  'require': '必要とします',
  'is-requestable-desc': 'ユーザーがこのアプリケーションを要求できるかどうかを示します。',
  'is-grantable-desc': 'このアプリケーションは、ユーザーに会社の管理によって直接付与することができますかどうかを示します',
  'is-displayable-desc': 'パッケージのアイコンがマイアプリケーションページに表示する必要があるかどうかを示します',
  'require-reason-desc': 'このパッケージは、このパッケージを要求する理由を供給するために、ユーザが必要かどうかを示します',
  'company-admin': '会社の管理',
  'application-admin': 'アプリケーションの管理',
  'company-admin-desc': 'これはデフォルトの承認フェーズで必要な他の相が存在しない場合は、それがはいでなければなりません',
  'application-admin-desc': 'ユーザアプリケーションの要求は、アプリケーション管理者によって承認される必要がありますか？',
  'add-admins': '管理者を追加します。',
  'cardinality-indicator': 'カーディナリティのインジケータ',
  'cui-one': '1',
  'cui-many': 'たくさんの',
  'claim-values': 'クレーム値',
  'cui-add': '加えます',
  'cui-view': 'ビュー',
  'cui-claim': '請求',
  'cui-category': 'カテゴリー',
  'cui-service': 'サービス',
  'cui-delete': '削除',
  'federation-conn': '連盟接続',
  'updated-date': '更新日',
  'target-url': 'ターゲットURL',
  'remote-app-id': 'リモートアプリケーションID',
  'mobile-sso-url': 'モバイルSSO URL',
  'mobile-app-id': 'モバイルアプリID',
  'cui-package': 'パッケージ',
  'cui-create': '作ります',
  'more-languages': 'その他の言語',
  'duplicate-language-error': '重複した言語が許可されていません',
  'cui-nextstep': '次',
  'create-package': 'パッケージを作成します。',
  'manage-package-claims': 'パッケージクレームを管理します',
  'cardinality-indicator-error': 'カーディナリティのインジケータは1にすることはできません',
  'value-id-exists': '値IDはすでに存在します',
  'claim-id-exists': '申し立てIDはすでに存在します',
  'cui-new': '新しい',
  'package-success-content': 'パッケージの作成に成功',
  'add-claims': 'クレームを追加',
  'package-update-success': 'パッケージが正常に更新します'
}
export {
  ja
}



// WEBPACK FOOTER //
// ./src/plugins/i18n/ja.js